/* ============================================================================
   VILLAINS TCG — Featured products rail (cst-product-rail.js)
   Native AJAX add-to-cart (loading/success/error, no reload), game-chip filtering,
   and a client-side shuffle for the "All products" source. Delegated where possible;
   re-inits on shopify:section:load so it stays correct in the Theme Editor.
   ========================================================================== */

/* Quick add-to-cart — delegated once at document level (covers every card). */
if (!window.__cstCardsBound) {
  window.__cstCardsBound = true;

  document.addEventListener('click', async (e) => {
    const add = e.target.closest('[data-cst-quick-add]');
    if (!add) return;
    e.preventDefault();
    if (add.classList.contains('is-loading')) return;

    const label = add.querySelector('.cst-product-card__cta-label') || add;
    const original = add.dataset.label || label.textContent;
    add.dataset.label = original;
    // loading — CSS hides the label and paints a centered spinner
    add.classList.remove('is-success', 'is-error');
    add.classList.add('is-loading');
    add.setAttribute('aria-busy', 'true');

    // `Theme` is a global lexical binding from scripts.liquid (not on window),
    // matching how Horizon's own scripts read it; typeof-guarded so it never throws.
    const routes = (typeof Theme !== 'undefined' && Theme.routes) || {};
    let ok = false;
    try {
      const res = await fetch(routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.variantId), quantity: 1 }] }),
      });
      ok = res.ok;
    } catch (_) { ok = false; }

    add.classList.remove('is-loading');
    add.removeAttribute('aria-busy');
    if (ok) {
      label.textContent = 'Added ✓';
      add.classList.add('is-success');
      document.dispatchEvent(new CustomEvent('cst:cart:refresh'));
    } else {
      label.textContent = 'Try again';
      add.classList.add('is-error');
    }
    clearTimeout(add._cstReset);
    add._cstReset = setTimeout(() => {
      label.textContent = original;
      add.classList.remove('is-success', 'is-error');
    }, 1600);
  });
}

/* "All products" source: Fisher–Yates shuffle the rendered pool on every load.
   The section's nth-child rule then shows only the first N items, so the visible
   subset AND its order are randomized each visit. Runs client-side → immune to
   full-page caching. */
const cstShuffle = (grid) => {
  const items = Array.from(grid.children);
  for (let i = items.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = items[i]; items[i] = items[j]; items[j] = tmp;
  }
  const frag = document.createDocumentFragment();
  items.forEach((el) => frag.appendChild(el));
  grid.appendChild(frag);
};

/* Game-chip filtering — bound once per rail (guarded so editor re-renders don't
   double-bind). */
const cstBindChips = (section) => {
  const chips = section.querySelector('[data-cst-chips]');
  const grid = section.querySelector('[data-cst-rail]');
  if (!chips || !grid || chips.dataset.cstBound) return;
  chips.dataset.cstBound = '1';
  const items = Array.from(grid.children);
  chips.querySelectorAll('[data-chip]').forEach((chip) => {
    chip.addEventListener('click', () => {
      const game = chip.dataset.chip;
      chips.querySelectorAll('[data-chip]').forEach((c) => {
        const on = c === chip;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      items.forEach((li) => { li.hidden = !(game === 'all' || li.dataset.game === game); });
    });
  });
};

const cstInitRails = (root) => {
  const scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('[data-cst-shuffle]').forEach(cstShuffle);
  scope.querySelectorAll('.cst-product-rail').forEach(cstBindChips);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => cstInitRails(document));
} else {
  cstInitRails(document);
}
// Theme Editor re-renders a section's markup and does not re-run this module.
document.addEventListener('shopify:section:load', (e) => cstInitRails(e.target || document));
